import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CableSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CableSVG;
